// @flow
import React from 'react'

const Cutlery = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="23" viewBox="0 0 20 23">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C" strokeLinecap="square">
        <path d="M8.5.5v8a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-8M4.5.5v6M4.5 10.5v12M19.5 15.5h-5v-11a4 4 0 0 1 4-4h1v15zM19.5 15.5v7" />
      </g>
    </svg>
  )
}

export default Cutlery



// WEBPACK FOOTER //
// ./src/components/Icons/Cutlery.js